import React from "react";
import { useFormikContext } from "formik";
import { Button } from "@mui/material";

import { logger } from "@/helpers/loggerHelper";

function FormikMuiSaveAsDraftButton({ label = "Save as Draft", ...rest }) {
  const { submitForm, isSubmitting, setFieldValue } = useFormikContext();

  const handleSaveAsDraft = async () => {
    try {
      setFieldValue("is_draft", true);
      await submitForm();
    } catch (err) {
      setFieldValue("is_draft", false);
      logger.error("Error in handleSaveAsDraft", err);
    }
  };

  return (
    <Button
      disabled={isSubmitting}
      {...rest}
      onClick={handleSaveAsDraft}
      type="button"
    >
      {label}
    </Button>
  );
}

export default FormikMuiSaveAsDraftButton;
